// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"jM-z","carouselContainer":"kM-z"};